import React from 'react'
import {Box,Typography} from "@mui/material"
import FilterNavbar from '../Filter/FilterNavbar'
import FiltersBreadCrumbs from './FiltersBreadCrumbs'
import Chef from './Chef'
import { LandingPageCards } from '../LandingPage1/LandingPageCards/LandingPageCards'
import AllMenu from './AllMenu'
import DiscountFooterSection from '../DiscountFooterSection/DiscountFooterSection'
import Footer from '../Footer/Footer'
import { useGetDishesCountryViseQuery } from 'api/menu'

const Filtered = () => {
    const { data : dishes, isLoading } = useGetDishesCountryViseQuery();
    console.log("dishes", dishes)
    

  return (
    <Box>
        <Box>
            <Box>
                <FilterNavbar/>
            </Box>
            <Box sx={{margin:'20px'}}>
            <Box sx={{mt:'60px'}}>
                <Box sx={{margin:'10px'}}><FiltersBreadCrumbs/></Box>
            </Box>
            <Box sx={{mt:"50px"}}>
                <Chef/>
            </Box>
            <Box sx={{
                mt:'30px',
                mb:'10px'
            }}>
                <Typography sx={{
                    fontWeight:600,
                    fontSize:'45px'
                }}>
                    Featured menu for you
                </Typography>
            </Box>
            <Box>
                <LandingPageCards dishes={dishes} />
            </Box>
            <Box>
                <AllMenu   />
            </Box>
            <Box sx={{mt:'90px'}}>
                <DiscountFooterSection/>
            </Box>
            </Box>
            <Box sx={{mt:'80px'}}>
                <Footer/>
            </Box>
        </Box>
    </Box>
  )
}

export default Filtered